export default function initSidebarUtils( { store, } ) {
	return {
		open() {
			store.commit( "host-layout/openNavSidebar" );
		},
		close() {
			store.commit( "host-layout/closeNavSidebar" );
		},
	};
}
